export const IReaderToolBarRepository = {
    getDefaultReaderTools: async () => { throw new Error('getDefaultReaderTools is not implemented'); },
    getLeftReaderTools: async () => { throw new Error('getLeftReaderTools is not implemented'); },
    getMiddleReaderTools: async () => { throw new Error('getMiddleReaderTools is not implemented'); },
    getRightReaderTools: async () => { throw new Error('getRightReaderTools is not implemented'); },
    getGuestReaderToolBarWhitelist: () => { throw new Error('getGuestReaderToolBarWhitelist is not implemented'); },
    getReaderToolboxCategory: () => { throw new Error('getReaderToolboxCategory is not implemented'); }
};
